import * as React from "react";
import {useEffect, useState} from "react";
import './Pick.css';
import '../../components/Typograph.css';
import AppHeader from '../../components/AppHeader';
import AppFooter from "../../components/AppFooter";
import {sendOfferteAanvraag} from "../../util/Send";
import PropTypes from "prop-types";

ContactPick.propTypes = {
    handleNextPage: PropTypes.func.isRequired,
    handlePreviousPage: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    allValues: PropTypes.object.isRequired,
}

export default function ContactPick(props) {
    const currentValue = props.allValues.ContactPick;

    const [file1, setFile1] = useState(null);
    const [file2, setFile2] = useState(null);
    const [file3, setFile3] = useState(null);
    const [file4, setFile4] = useState(null);
    const [disableNavigation, setDisableNavigation] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            const data = JSON.parse(JSON.stringify(currentValue || {}));

            if (value("aanhef") === "") {
                data["aanhef"] = "Dhr";
            }
            if (value("land") === "") {
                data["land"] = "NL";
            }

            if (value("finished") === "") {
                data["finished"] = "ja";
            }

            const account = window.account;
            if (account) {
                data.voornaam = account.firstname;
                data.achternaam = account.lastname;
                data.land = account.deliveryAddress.countryCode;
                data.straat = account.deliveryAddress.street
                data.huisnummer = account.deliveryAddress.number
                data.toevoeging = account.deliveryAddress.addition
                data.postcode = account.deliveryAddress.zipcode;
                data.woonplaats = account.deliveryAddress.city;
                data.email = account.email;
            }
            props.handlePageChange(data);
        }, 1);
    }, []);

    const onChange = (field) => (e: InputEvent) => {
        const data = JSON.parse(JSON.stringify(currentValue || {}));
        data[field] = e.currentTarget.value;
        props.handlePageChange(data);
    }

    const value = (field) => {
        const val = (currentValue || {})[field];
        return val != null ? val : "";
    }

    const onNext = () => {
        function realValue(val) {
            if (val.text != null) {
                return `${val.value} ${val.text}`;
            }
            return val;
        }

        const c = currentValue || {};
        const wrong = [];

        const email = c.email;
        if (email == null || email === "" || !email.includes('@')) {
            wrong.push("E-mail");
        }

        const huisnummer = c.huisnummer;
        if (huisnummer == null || huisnummer === "") {
            wrong.push("Huisnummer");
        }

        const voornaam = c.voornaam;
        if (voornaam == null || voornaam === "") {
            wrong.push("Voornaam");
        }

        const achternaam = c.achternaam;
        if (achternaam == null || achternaam === "") {
            wrong.push("Achternaam");
        }

        const postcode = c.postcode;
        if (postcode == null || postcode === "" || postcode.length < 6) {
            wrong.push("Postcode");
        }

        const straat = c.straat;
        if (straat == null || straat === "") {
            wrong.push("Straat");
        }

        const woonplaats = c.woonplaats;
        if (woonplaats == null || woonplaats === "") {
            wrong.push("Woonplaats");
        }

        if (wrong.length > 0) {
            alert("U heeft niet alle velden (volledig) ingevuld:\n" + wrong.join(', '));
            return;
        }

        setDisableNavigation(true);

        sendOfferteAanvraag({
                type: realValue(props.allValues.TypePick),
                versie: realValue(props.allValues.VersionPick),
                sluiting: realValue(props.allValues.ClosingPick),
                vastzetter: realValue(props.allValues.FastenerPick),
                situaties: props.allValues.SituationPick.data, //[{kozijnen, luiken, breedte, hoogte, montage, draaitype, hengtype, maatD, maatM, maatT, maatA, maatK, maatS, maatY}] all String?
                info: props.allValues.ContactPick //{extraInfo?, email, finished, huisnummer, toevoeging?, mobile?, voornaam, achternaam, aanhef, postcode, straat, tel?, woonplaats}
            }, file1, file2, file3, file4
        ).then(r => {
            if (r.ok) {
                props.handleNextPage();
            } else {
                setDisableNavigation(false);
                console.log("Error sending 'offerte aanvraag': " + r.status);
                alert("Er is helaas iets mis gegaan bij het versturen van uw aanvraag.\nGraag later opnieuw proberen of zelf mailen naar info@luikbeslagshop.nl")
            }
        });
    }


    const maxFileSize = 5 * 1024 * 1024;
    return (
        <div className="page">
            <AppHeader title="Contact informatie"/>

            <div className="page-middle">
                <div style={{margin: "10px"}}>
                    <h4>Heeft u nog opmerkingen, vragen of belangrijke informatie?</h4>
                    <textarea className={"extra-info"} value={value("extraInfo")}
                              onChange={onChange("extraInfo")}/>
                    <hr/>
                    <h4>Indien gewenst kunt u foto's of illustraties meesturen:</h4>
                    <div>
                        <input type="file" style={{width: "50%"}}
                               onChange={e => {
                                   if (e.target.files[0].size > maxFileSize) {
                                       alert("U kunt alleen bestanden opsturen onder de 5 MB");
                                       e.target.value = '';
                                   } else {
                                       setFile1(e.target.files[0]);
                                   }
                               }}/>
                        <input type="file" style={{width: "50%"}}
                               onChange={e => {
                                   if (e.target.files[0].size > maxFileSize) {
                                       alert("U kunt alleen bestanden opsturen onder de 5 MB");
                                       e.target.value = '';
                                   } else {
                                       setFile2(e.target.files[0]);
                                   }
                               }}/>
                        <input type="file" style={{width: "50%"}}
                               onChange={e => {
                                   if (e.target.files[0].size > maxFileSize) {
                                       alert("U kunt alleen bestanden opsturen onder de 5 MB");
                                       e.target.value = '';
                                   } else {
                                       setFile3(e.target.files[0]);
                                   }
                               }}/>
                        <input type="file" style={{width: "50%"}}
                               onChange={e => {
                                   if (e.target.files[0].size > maxFileSize) {
                                       alert("U kunt alleen bestanden opsturen onder de 5 MB");
                                       e.target.value = '';
                                   } else {
                                       setFile4(e.target.files[0]);
                                   }
                               }}/>
                    </div>
                    <hr/>
                    <h4>Het luikbeslag is voor</h4>
                    <div>
                        <input type="radio" value="ja" id="finished-yes"
                               checked={value("finished") === "ja"}
                               onChange={onChange("finished")}/>
                        <label htmlFor="finished-yes">bestaande luiken</label><br/>
                        <input type="radio" value="nee" id="finished-no"
                               checked={value("finished") === "nee"}
                               onChange={onChange("finished")}/>
                        <label htmlFor="finished-no">nog te maken luiken</label>
                    </div>
                    <hr/>
                    <h4>Uw gegevens</h4>
                    <div className={"form"}>
                        <div className={"form-part"}>
                            <div>
                                <div>Voor- en achternaam*</div>
                                <select onChange={onChange("aanhef")} value={value("aanhef")}>
                                    <option value="Dhr">Dhr</option>
                                    <option value="Mw">Mw</option>
                                </select>
                                <input type="text" className={"form-input"} value={value("voornaam")}
                                       onChange={onChange("voornaam")} size="16"/>
                                <input type="text" className={"form-input"} value={value("achternaam")}
                                       onChange={onChange("achternaam")} size="17"/>
                            </div>
                        </div>
                        <div className={"form-part"}>
                            <div>
                                <div>Land</div>
                                <select onChange={onChange("land")} value={value("land")}>
                                    <option value="NL">Nederland</option>
                                    <option value="BE">België</option>
                                    <option value="DE">Duitsland</option>
                                    <option value="FR">Frankrijk</option>
                                </select>
                            </div>
                        </div>
                        <div className={"form-part"}>
                            <div>
                                <div>Straat*</div>
                                <input type="text" value={value("straat")} onChange={onChange("straat")}
                                       size="26"/>
                            </div>
                            <div>
                                <div className={"form-input"}>Huisnummer*</div>
                                <input className={"form-input"} type="text" value={value("huisnummer")}
                                       onChange={onChange("huisnummer")} size="5"/>
                            </div>
                            <div>
                                <div>Toev.</div>
                                <input type="text" value={value("toevoeging")} onChange={onChange("toevoeging")}
                                       size="3"/>
                            </div>
                        </div>
                        <div className={"form-part"}>
                            <div>
                                <div>Postcode*</div>
                                <input type="text" value={value("postcode")}
                                       onChange={onChange("postcode")}
                                       size="6"/>
                            </div>
                            <div>
                                <div className={"form-input"}>Woonplaats*</div>
                                <input className={"form-input"} type="text" value={value("woonplaats")}
                                       onChange={onChange("woonplaats")} size="29"/>
                            </div>
                        </div>
                        <div className={"form-part"}>
                            <div>
                                <div>E-mail*</div>
                                <input type="email" value={value("email")} onChange={onChange("email")}
                                       size="41"/>
                            </div>
                        </div>
                        <div className={"form-part"}>
                            <div>
                                <div>Tel.</div>
                                <input type="tel" value={value("tel")} onChange={onChange("tel")}
                                       size="17"/>
                            </div>
                            <div>
                                <div className={"form-input"}>Mobiel</div>
                                <input className={"form-input"} type="mobile" value={value("mobile")}
                                       onChange={onChange("mobile")} size="18"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {disableNavigation
                ? <AppFooter
                    onNext={onNext}
                    enableNext={false}
                    send={true}/>
                : <AppFooter onNext={onNext}
                             onPrevious={() => {
                                 if (window.confirm("Als u terug gaat moet u de foto's opnieuw invoeren\nToch teruggaan?")) {
                                     props.handlePreviousPage();
                                 }
                             }}
                             enableNext={currentValue}
                             send={true}/>
            }
        </div>
    );
}
